import ButtonDefault from './Default.vue';

export { ButtonDefault };

export default ButtonDefault;


// WEBPACK FOOTER //
// ./src/components/parts/button/index.ts